var AdaptiveImage = require("../../../../../../../../react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/close-icon.992cf1d3.png","uri@2x": __webpack_public_path__ + "static/media/close-icon.51268883.png","uri@3x": __webpack_public_path__ + "static/media/close-icon.be7f1562.png",
    width: 96,
    height: 96
});